import * as React from "react";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import { MomentDateFormat } from "../../../core/models/enums/core.enums";
import PrwcTimeline from "../../../ui/widgets/custom/PrwcTimeline";
import { Activity } from "../../models/interfaces/profile-summary.interface";

type ProfileUserActivitiesProps = {
  activities: Activity[];
};

const ProfileUserActivities = (props: ProfileUserActivitiesProps) => {
  const { activities } = props;
  const { t } = useTranslation();

  const customizedMarker = () => {
    return <span className="w-4 h-4 bg-blue-700 rounded-full"></span>;
  };

  const customizedContent = (item: Activity) => {
    return (
      <div className="flex flex-col justify-between w-auto text-sm sm:flex-row">
        <div>
          <div className="font-semibold text-gray-700">{item.activityType}</div>
          <div>{item.summary}</div>
        </div>
        <div className="my-2 sm:my-0">
          <div className="font-semibold text-gray-700">
            {t("profileSummary.label.updatedOn")}
          </div>
          <div className="text-xs text-gray-500">
            <Moment date={item.updatedOn} format={MomentDateFormat.LLL}/>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div >
      <div className="-ml-6">
        <PrwcTimeline
          events={activities}
          marker={customizedMarker}
          content={customizedContent}
        ></PrwcTimeline>
      </div>
    </div>
  );
};

export default ProfileUserActivities;
